<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="content-page-header">
            <h5>Approved Transactions</h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a class="btn-filters w-auto popup-toggle"
                    ><span><i class="feather feather-filter"></i></span>
                  </a>
                </li>
                <li>
                  <a @click="openWithdrawModal" class="btn btn-primary"
                    ><span
                      ><i class="feather feather-upload me-2"></i>Withdraw
                    </span></a
                  >
                </li>
                <!-- <li>
                  <a @click="openDepositModal" class="btn btn-primary"
                    ><i class="feather feather-download me-2"></i>Add Funds</a
                  >
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->
        <balancecard />
   <transactiontab v-model="searchForm.search" />

        <!-- Add Asset -->
        <div class="toggle-sidebar">
          <div class="sidebar-layout-filter">
            <div class="sidebar-header">
              <h5>Filter</h5>
              <a href="javascript:;" class="sidebar-closes"
                ><i class="fa-regular fa-circle-xmark"></i
              ></a>
            </div>
            <div class="sidebar-body">
              <b-form action="#" autocomplete="off">
                <!-- Customer -->
                <div class="accordion" id="accordionMain1">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div class="card-header-new" id="headingOne">
                      <h6 class="filter-title">
                        Transaction
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample1"
                  >
                    <div class="card-body-chat">
                      <div class="row">
                        <div class="col-md-12">
                          <div id="checkBoxes1">
                            <div class="form-custom">
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchForm.search"
                                id="member_search1"
                                placeholder="Search here"
                              />
                              <span
                                ><img
                                  src="@/assets/img/icons/search.svg"
                                  alt="img"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Customer -->

                <!-- Select Date -->
                <div class="accordion" id="accordionMain2">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div class="card-header-new" id="headingTwo">
                      <h6 class="filter-title">
                        Select Date
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div class="card-body-chat">
                      <div class="form-group">
                        <label class="form-control-label">From</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="startdate"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">To</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="startdate"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Select Date -->

                <!-- Category -->
                <div class="accordion accordion-last" id="accordionMain4">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="true"
                    aria-controls="collapseFour"
                  >
                    <div class="card-header-new" id="headingFour">
                      <h6 class="filter-title">
                        Type
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseFour"
                    class="collapse show"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample4"
                  >
                    <div class="card-body-chat">
                      <div id="checkBoxes1">
                        <div class="form-custom">
                          <b-form-select
                            class="search-select"
                            v-model="searchForm.type"
                            :options="typeOptions"
                          ></b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Category -->

                <button
                  @click="resetSearchForm"
                  class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
                >
                  <span><i class="feather feather-refresh-ccw me-2"></i></span
                  >Reset
                </button>
              </b-form>
            </div>
          </div>
        </div>
        <!--/Add Asset -->

        <div class="row">
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :data-source="transactions.data"
                    :pagination="false"
                    :loading="isFetching"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        <span>{{ index + 1 }}</span>
                      </template>
                      <template v-else-if="column.key === 'reference'">
                        {{ record.reference }}
                      </template>
                      <template v-else-if="column.key === 'amount'">
                        <span>{{
                          `${record.currency} ${addCurrencyComma(
                            record.amount
                          )}`
                        }}</span>
                      </template>
                      <template v-else-if="column.key === 'created_at'">
                        <span>{{ formatDateWIthTime(record.created_at) }}</span>
                      </template>
                      <template v-else-if="column.key === 'type'">
                        <span
                          class="badge bg-danger-light text-capitalize"
                          v-if="record.type === 'payout'"
                          >{{ record.type }}</span
                        >
                        <span
                          class="badge bg-success-light text-capitalize"
                          v-else
                          >{{ record.type }}</span
                        >
                      </template>
                      <template v-else-if="column.key === 'method'">
                        <span class="text-capitalize">{{ record.method }}</span>
                      </template>
                      <template v-else-if="column.key === 'status'">
                        <span
                          class="badge bg-success-light text-success-light text-capitalize"
                          v-if="record.status === 'approved'"
                          >{{ record.status }}</span
                        >
                        <span
                          class="badge bg-warning-light text-warning-light text-capitalize"
                          v-else-if="record.status === 'pending'"
                          >{{ record.status }}</span
                        >
                        <span
                          class="badge bg-danger-light text-capitalize"
                          v-else-if="record.status === 'declined'"
                          >{{ record.status }}</span
                        >
                      </template>
                    </template>
                  </a-table>
                </div>
                <div class="d-flex justify-content-end">
                  <a-pagination
                    class="mt-4"
                    :current="currentPage"
                    :total="total"
                    :page-size="perPage"
                    :show-size-changer="false"
                    :show-quick-jumper="false"
                    @change="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Deposit Modal -->
  <div class="modal custom-fade fade" id="deposit_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Deposit</h3>
            <div class="form-group text-start mt-2">
              <label>Amount</label>
              <b-form-input
                type="text"
                v-model="depositForm.amount"
                class="form-control"
                placeholder="Enter the Amount"
              />
            </div>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <button
                  @click="depositFund"
                  class="w-100 btn btn-primary"
                  :disabled="isDepositing"
                >
                  <span
                    v-if="isDepositing"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isDepositing">Deposit</span>
                  <span v-if="isDepositing">Depositing...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  @click="closeDepositModal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Deposit Modal -->
  <withdrawmodal
    @closeWithdrawalModal="closeWithdrawModal"
    @getTransactions="getTransactions"
  />
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { addCurrencyComma } from "@/assets/composables/currency";
import { formatDateWIthTime } from "@/assets/composables/date";
import { useStore } from "vuex";
import { Modal } from "bootstrap";

const store = useStore();
const isFetching = ref(false);
const currentDate = ref(new Date());
const startdate = ref(currentDate.value);
const currentPage = ref(1);
const perPage = ref(50);
const depositModalInstance = ref(null);
const withdrawModalInstance = ref(null);
const isDepositing = ref(false);
const depositForm = ref({
  amount: "",
});

const typeOptions = [
  { value: "", text: "Please select type" },
  { value: "deposit", text: "Deposit" },
  { value: "debit", text: "Debit" },
];

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getTransactions();
});

const searchForm = ref({
  search: "",
  type: "",
});

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
    type: "",
  };
};

watch(
  () => searchForm.value,
  (newValue) => {
    let data = {
      page: currentPage.value,
      per_page: perPage.value,
      type: newValue.type,
      query: newValue.search,
    };
    store.dispatch("transaction/getTransactions", data);
  },
  { deep: true }
);

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Reference ID",
    key: "reference",
    sorter: true,
  },
  {
    title: "Amount",
    key: "amount",
    sorter: true,
  },
  {
    title: "Date",
    key: "created_at",
    sorter: true,
  },
  {
    title: "Type",
    key: "type",
    sorter: true,
  },
  {
    title: "Method",
    key: "method",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
];

const openDepositModal = () => {
  depositModalInstance.value.show();
};
const closeDepositModal = () => {
  depositModalInstance.value.hide();
};

const openWithdrawModal = () => {
  withdrawModalInstance.value.show();
};
const closeWithdrawModal = () => {
  withdrawModalInstance.value.hide();
};

const transactions = computed(() => {
  return store.getters["transaction/transactions"];
});
const total = computed(() => {
  return store.getters["transaction/total"];
});

const getTransactions = () => {
  isFetching.value = true;
  let data = {
    page: currentPage.value,
    per_page: perPage.value,
    type: "",
    query: "approved",
  };
  store
    .dispatch("transaction/getTransactions", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

const depositFund = () => {
  isDepositing.value = true;
  store
    .dispatch("transaction/depositFund", depositForm.value)
    .then(() => {
      isDepositing.value = false;
      closeDepositModal();
      getTransactions();
      depositForm.value.amount = "";
    })
    .catch(() => {
      isDepositing.value = false;
      closeDepositModal();
      depositForm.value.amount = "";
    });
};

onMounted(() => {
  getTransactions();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }

  // Initiate deposit modal
  depositModalInstance.value = new Modal(
    document.getElementById("deposit_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
  // Initiate withdraw modal
  withdrawModalInstance.value = new Modal(
    document.getElementById("withdraw_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
});
</script>
